import { UI } from '../nextpage';
import { SearchType } from '../utilities/enums';

export class Search {
    searchType: SearchType;
    searchAction = 'https://www.office.com/search?auth=2';
    searchRoot = '';

    constructor(private NP: UI) { 
        this.NP.registerEvent("searchClick", (e: Event) => {
            e.stopImmediatePropagation();
        });
        this.NP.registerEvent("searchToggleClick", (e: Event) => {
            e.stopImmediatePropagation();
            const search = document.getElementById("search") as HTMLDivElement;
            const searchToggle = document.getElementById("toggle-search") as HTMLElement;
            const searchExpanded = search.classList.contains("aria-expanded");
            this.NP.blurPromise(e.target as Element).then(() => {
                if (searchExpanded) {
                    this.NP.toggleAriaState(search, "expanded", false);
                    this.NP.toggleAriaState(searchToggle, "pressed", false);
                    return;
                }
                this.NP.toggleAriaState(search, "expanded", true);
                this.NP.toggleAriaState(searchToggle, "pressed", true);
                this.NP.properties.blurAria.push(
                    {selector: search, class: 'expanded', active: false},
                    {selector: searchToggle, class: 'pressed', active: false}
                );
            }).catch(rejection => console.log(`searchToggleClick event broken promise: ${rejection}`));
        });
        this.NP.registerEvent("searchSubmitClick", (e: Event) => {
            const searchText = document.querySelector("#search-text") as HTMLInputElement;
            if (searchText === null) {
                e.preventDefault();
                return;
            }
            const searchVal = searchText.value;
            if (searchVal === undefined || searchVal === null || searchVal === "") {
                e.preventDefault();
                return;
            }
            window.setTimeout(function () {
                const searchClear = document.querySelector("#search-clear");
                const searchToggle = document.querySelector("#toggle-search");
                if (searchClear !== null) {
                    searchClear.dispatchEvent(new Event("click"));
                }
                if (searchToggle !== null) {
                    searchToggle.dispatchEvent(new Event("click"));
                }
            }, 125);
        });
        
        this.NP.registerEvent("searchSiteSpecificClick", (e: Event) => {
            e.preventDefault();
            const siteSearchText = document.getElementById('site-search-text') as HTMLInputElement;
            const siteSearchFilter = document.getElementById('site-search-filter') as HTMLInputElement;
            if (siteSearchText === null || siteSearchFilter === null) {
                return;
            }
            const searchTextVal = siteSearchText.value;
            const siteFilterVal = siteSearchFilter.value;
            if (searchTextVal === undefined || searchTextVal === null || searchTextVal === "") {
                e.preventDefault();
                return;
            }
            if (siteFilterVal === undefined || siteFilterVal === null || siteFilterVal === "") {
                e.preventDefault();
                console.log("This component requires the #site-search-filter input element to have a value.");
                return;
            }
            const fullSearchPath = encodeURIComponent(searchTextVal) + ' ' + encodeURIComponent('path:' + siteFilterVal);
            const fullSearchUrl = this.searchAction + (this.searchAction.indexOf('?') === -1 ? '?' : '&') + 'q=' + fullSearchPath;
            window.open(fullSearchUrl, '_blank');
            window.setTimeout(function() {
                const searchText = document.getElementById('site-search-text') as HTMLInputElement;
                if (searchText === undefined) {
                    return;
                }
                searchText.value = '';
            }, 125);
        });

        this.NP.components.globalSearch = (): void => {
            // Global Search Events
            const search = document.getElementById('search');
            const searchToggle = document.getElementById('toggle-search');
            const searchForm = document.getElementById('search-form');

            if (search !== null) {
                search.addEventListener("click", (ev: Event) => { this.NP.events.searchClick(ev); });
            }
            if (searchToggle !== null) {
                searchToggle.addEventListener("click", (ev: Event) => { this.NP.events.searchToggleClick(ev); });
            }
            if (searchForm !== null) {
                searchForm.addEventListener("click",  (ev: Event) => { this.NP.events.searchSubmitClick(ev); });
            }
        }

        this.NP.components.globalSiteSpecificSearch = (): void => {
            // Global Site Specific Search Events
            const siteSearch = document.getElementById('site-search');
            if (siteSearch !== null) {
                siteSearch.addEventListener("submit", (ev: Event) => { this.NP.events.searchSiteSpecificClick(ev); });
            }
        }
    }
}